import DealerProvider from './DealerContext';
import Dealer from './Dealer';


let Index = () => {
    return (
        <DealerProvider>
            <Dealer />
        </DealerProvider>
    )
}

export default Index;